import type { ReactiveControllerHost } from 'lit';
import type { PlayForRealInfo } from '../../../../_ui-core_/base/package/api/package/casino/casino-domain';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type PushEvent = {
  method: string;
  data: unknown;
};

export default class PushGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'pushgaming');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      if (!info.launchConfig.launchUrl) {
        return Promise.reject(new CustomError('Launch URL is missing in launchConfig.', { code: 404 }));
      }

      const url = new URL(info.launchConfig.launchUrl);
      url.searchParams.set('lang', PushGameController.formatLanguage(info.language));

      return url.toString();
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: string | object): EventAction | null {
    window.$app.logger.log('message', data);

    if (typeof data === 'string') {
      switch (data) {
        case 'gamePlayAnimationStarted':
          return this.markActivity();
        case 'gamePlayAnimationComplete':
          return this.markActivityAndSpinSuccess();
      }
    }

    const action = (data as PushEvent).method;

    switch (action) {
      case 'gotoLobby':
        return this.closeGame();
    }

    return null;
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }

  // @ts-expect-error
  private static formatGameMode(playForReal?: PlayForRealInfo): string {
    return playForReal ? 'REAL' : 'DEMO';
  }

  private static formatLanguage(code: string): string {
    switch (code) {
      case 'en':
        return 'en';
      default:
        return 'de';
    }
  }
}
